import React from 'react';
import FacebookIcon from '../icons/FacebookIcon';
import RedditIcon from '../icons/RedditIcon';
import YoutubeIcon from '../icons/YoutubeIcon';
import InstagramIcon from '../icons/InstagramIcon';
import TwitterIcon from '../icons/TwitterIcon';
import DiscordIcon from '../icons/DiscordIcon';
import '../css/socialBar.css';

const SocialBar = () => {
    return (
        <div className="social-bar">
            <a href="https://twitter.com/playsuperpeople" target="_blank" rel="noopener noreferrer">
                <TwitterIcon size={24} color="white" />
            </a>
            <a href="https://facebook.com/playsuperpeople" target="_blank" rel="noopener noreferrer">
                <FacebookIcon size={24} color="white" />
            </a>
            <a href="https://www.reddit.com/r/SuperPeople/" target="_blank" rel="noopener noreferrer">
                <RedditIcon size={24} color="white" />
            </a>
            <a href="https://www.youtube.com/@SuperPeopleOfficialEN/" target="_blank" rel="noopener noreferrer">
                <YoutubeIcon size={24} color="white" />
            </a>
            <a href="https://instagram.com/playsuperpeople" target="_blank" rel="noopener noreferrer">
                <InstagramIcon size={24} color="white" />
            </a>
            <a href="https://discord.gg/superpeopleofficial" target="_blank" rel="noopener noreferrer">
                <DiscordIcon size={24} color="white" />
            </a>
        </div>
    );
};

export default SocialBar;
